export enum WebhookEvents {
  partyCreated = 'party.created',
  partyUpdated = 'party.updated',
  partyCheckedIn = 'party.checked_in',
  partyMarked = 'party.marked',
}
